
const BoostAdsPage = () => {
     return (
          <div>
               boosting your ads
          </div>
     )
}

export default BoostAdsPage